/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import Twemoji from 'twemoji'
import "css/application"
import { setupSearchSuggest } from "../search_suggest"
import { setupGallery } from "../gallery"
import { setupIngredientFilter } from "../ingredient_filter"
import { setupHeroWaves } from "../hero_waves"
import { setupRating } from "../rating"

// © ® ™ restano testo: Twemoji li trasformerebbe in piccole immagini grigie,
// poco leggibili (sul fondo laguna del piè di pagina quasi spariscono)
const TEXT_SYMBOLS = ['a9', 'ae', '2122'];
const twemojiOptions = {
  callback: (icon, options) =>
    TEXT_SYMBOLS.includes(icon) ? false : ''.concat(options.base, options.size, '/', icon, options.ext)
};

// Nell'area riservata niente emoji in immagine: le frecce restano testo
document.addEventListener("turbolinks:load", function(){
  if (!document.body.classList.contains('adm-body')) Twemoji.parse(document.body, twemojiOptions);
  setupSearchSuggest();
  setupGallery();
  setupIngredientFilter();
  setupHeroWaves();
  setupRating();
})
